"use client";

import Link from "next/link";
import { useParams, useSearchParams } from "next/navigation";
import { useQuery } from "@tanstack/react-query";
import { adminUserRead, UserAdminPath, UserAdminTitle } from "@/entities";
import { AdminBreadcrumb, PanelError, PanelLoader, AdminTitle } from "@/shared";
import {
  AdminCommonFileCoverEdit,
  AdminUserAlert,
  AdminUserFrom,
} from "@/features";

export function AdminUserViewPage() {
  const params = useParams<{ id: string }>();
  const searchParams = useSearchParams();

  const id = params?.id || "";

  const { error, isLoading, data } = useQuery({
    queryKey: [`admin-users-${id}`],
    queryFn: () => adminUserRead({ id }),
  });

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={UserAdminPath} />
          <AdminTitle title={UserAdminTitle} />
        </div>
        <div className="ms-auto">
          <Link
            href={{ pathname: `/admin/users`, query: searchParams?.toString() }}
            className="btn btn-white"
            role="button"
          >
            <i className="fa fa-list"></i>
            <span> 목록</span>
          </Link>
        </div>
      </div>

      <AdminUserAlert />

      {error ? (
        <PanelError error={error} />
      ) : (
        <>
          <div className="row">
            <div className="col-md-12">
              {isLoading ? (
                <PanelLoader panelTitle="프로필 이미지" />
              ) : (
                <AdminCommonFileCoverEdit
                  panelTitle="프로필 이미지"
                  queryKey={`admin-users-${id}`}
                  table="user"
                  column="cover"
                  id={data?.result.id}
                  timestamp={data?.result.timestamp}
                  file={data?.result.cover}
                  accept="image/*"
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {isLoading ? (
                <PanelLoader panelTitle="회원 정보" />
              ) : (
                <AdminUserFrom panelTitle="회원 정보" data={data} />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
